import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PRONTUARIO_PATIENT_CARD_CLASS } from '../../constants/prontuarioTheme';
import type { ProntuarioPatientHeader } from '../../utils/resolveProntuarioPatientHeader';
import { SessionCallProntuarioPatientSummary } from './SessionCallProntuarioPatientSummary';

type SessionCallProntuarioPatientCardProps = {
	header: ProntuarioPatientHeader;
	onOpenProfile?: () => void;
	className?: string;
	tutorialDemoTarget?: string;
};

const SessionCallProntuarioPatientCard = ({
	header,
	onOpenProfile,
	className,
	tutorialDemoTarget,
}: SessionCallProntuarioPatientCardProps) => (
	<button
		type="button"
		onClick={onOpenProfile}
		{...(tutorialDemoTarget
			? { 'data-tutorial-demo': tutorialDemoTarget }
			: {})}
		className={cn(
			'group w-full p-4 text-left',
			PRONTUARIO_PATIENT_CARD_CLASS,
			className,
		)}
	>
		<SessionCallProntuarioPatientSummary
			header={header}
			trailing={
				<ChevronRight
					className="size-5 shrink-0 text-slate-500"
					strokeWidth={2.25}
					aria-hidden
				/>
			}
		/>
	</button>
);

export { SessionCallProntuarioPatientCard };
